export default "__VITE_ASSET__DDHroIvW__"